import React, { useRef, useState } from "react";
import { queue, uid, nowHM, post, phoneText } from "./techData";
import { woOf } from "./woLive";
import CompletePopup from "./CompletePopup";
import { RunbackPicker, Notice } from "./ClosePopups";

const DONE_SMS = "I have completed your pool works. If you have any questions, please do not hesitate to call or SMS me or you can call the office on 0249437311. If you have already paid for these works, no further action is required, however, if not, the office will email your invoice and if you would be kind enough to settle any invoice amount within 7 Days, this would be tremendously appreciated. Thank you for your business.";

const ampm = (hm) => { if (!hm) return ""; const [h, m] = hm.split(":").map(Number); return `${h % 12 || 12}:${String(m).padStart(2, "0")}${h < 12 ? "am" : "pm"}`; };
// time on site, rounded to the nearest 15 min (never less than 15 min)
export const onSite = (a, b) => {
  const [ah, am] = a.split(":").map(Number), [bh, bm] = b.split(":").map(Number);
  let mins = bh * 60 + bm - (ah * 60 + am);
  if (mins < 0) mins += 1440;
  const r = Math.max(15, Math.round(mins / 15) * 15), h = Math.floor(r / 60), m = r % 60;
  return [h && `${h}hr`, m && `${m}min`].filter(Boolean).join(" ");
};

const Stamp = ({ label, time, onClick, bg, testid }) => (
  <button onClick={onClick} data-testid={testid} className="w-full h-[46px] rounded-full px-6 flex items-center justify-between text-white font-black text-[19px] shadow-sm active:scale-[0.98] transition-transform" style={{ background: bg }}>
    <span className={time ? "text-amber-200" : ""}>{label}</span><span data-testid={`${testid}-time`}>{ampm(time)}</span>
  </button>
);

const Act = ({ label, onClick, cls, testid }) => (
  <button onClick={onClick} data-testid={testid} className={`h-[58px] rounded-full px-2 text-[15px] font-bold leading-[1.1] shadow-sm active:scale-[0.97] transition-transform ${cls}`}>{label}</button>
);

export default function JobButtons({ v, setV, date, warn, setWarn, nav }) {
  const lock = useRef(false);
  const [busy, setBusy] = useState(false), [fin, setFin] = useState(null), [pick, setPick] = useState(false), [note, setNote] = useState(null);
  const stampStart = () => { if (!v.start) { setV({ start: nowHM() }); setWarn(""); } };
  const stampFinish = () => { if (!v.start) return setWarn("Tap Arrived on Site first."); if (!v.finish) { setV({ finish: nowHM() }); setWarn(""); } };
  const check = () => {
    if (!v.start || !v.finish) { setWarn(`Tap ${!v.start ? "Arrived on Site" : "Finished on Site"} first.`); return false; }
    if (!v.wo_id) { setWarn("There's no work order for this job yet."); return false; }
    return true;
  };
  const me = () => (JSON.parse(localStorage.getItem("tech:user") || "{}").name || "").split(" ")[0];
  const timeLine = () => `${me()} arrived on site @ ${ampm(v.start)} and finished on site @ ${ampm(v.finish)} = ${onSite(v.start, v.finish)}`;
  const complete = async () => {
    if (!check() || lock.current) return;
    lock.current = true; setBusy("complete");
    const body = { ref: uid(), date: v.date || date, text: timeLine(), reminder_id: v.reminder_id || null };
    let res = null;
    try { res = await post(`/tech/workorder/${v.wo_id}/job-complete`, body); } catch (e) {
      if (navigator.onLine) { lock.current = false; setBusy(false); return setWarn(e.message); }
      queue(`complete:${v.wo_id}`, "POST", `/tech/workorder/${v.wo_id}/job-complete`, body);
    }
    const texted = textClient(DONE_SMS);
    reset(); lock.current = false; setBusy(false); setFin({ res, texted });
  };
  const textClient = (msg) => {
    const c = JSON.parse(localStorage.getItem(`tc:/tech/client/${v.client_id}`) || "{}"), wo = woOf(v.client_id, v.wo_id) || {};
    const first = (c.first_name || (c.name || "").split(" ")[0] || "there").trim();
    return phoneText(v.client_id, `Hi ${first}, ${me()} from ${wo.invoiced_by || "Glamour Pools and Spas"}. ${msg}`, null, true);
  };
  // visit closed off: the job screen starts fresh next time
  const reset = () => { setV({ start: null, finish: null, checklist: [], checklist_done: [], extra_items: [], parts: [], labour: [], photos: [], water_test_ref: null, notes: "" }); setWarn(""); };
  const shut = async (action, returnDate, why = "") => {
    if (lock.current) return;
    lock.current = true; setBusy(action);
    const body = { action, ref: uid(), date: v.date || date, text: `${timeLine()}${why ? ` - Runback reason: ${why}` : ""}`, reminder_id: v.reminder_id || null, return_date: returnDate, reason: why };
    let res = null;
    try { res = await post(`/tech/workorder/${v.wo_id}/job-close`, body); } catch (e) {
      if (navigator.onLine) { lock.current = false; setBusy(false); setPick(false); return setWarn(e.message); }
      queue(`close:${v.wo_id}`, "POST", `/tech/workorder/${v.wo_id}/job-close`, body);
    }
    const when = returnDate && new Date(`${returnDate}T12:00:00`).toLocaleDateString("en-AU", { weekday: "long", day: "2-digit", month: "2-digit", year: "numeric" });
    const texted = textClient(action === "runback"
      ? `I was not able to complete your job today${why ? ` (${why.toLowerCase()})` : ""} and I have scheduled to return on ${when}. If you have any questions, please feel free to call or sms me or you can call the office on 0249437311.`
      : "I have attended site and have passed on the details for the office to prepare your quotation. Please do not hesitate to call or sms me or you can call the office on 0249437311.");
    const txt = texted ? "Your Messages app has the text to the client ready - add anything extra and tap Send." : "There's no mobile number for this client, so no text was sent.";
    reset(); lock.current = false; setBusy(false); setPick(false);
    setNote(action === "runback"
      ? [`Thanks ${me()}, your runback is set for ${when} and a new magnet has been placed on the whiteboard.`, res ? "" : "No signal right now - it will be saved as soon as you have signal.", txt]
      : [`Thanks ${me()}, a reminder has been set for ${res?.kevin || "Kevin"} to Create Client Quotation.`, res ? "" : "No signal right now - it will be saved as soon as you have signal.", txt]);
  };
  return (
    <div className="space-y-2">
      {warn && <div className="rounded-xl bg-red-50 border-2 border-red-300 text-red-800 text-[15px] font-bold px-3 py-2" data-testid="tech-job-warn">{warn}</div>}
      <Stamp label="Arrived on Site" time={v.start} bg="#1e4f8a" onClick={stampStart} testid="tech-start-btn" />
      <Stamp label="Finished on Site" time={v.finish} bg="#7b1f8a" onClick={stampFinish} testid="tech-leave-btn" />
      <div className="grid grid-cols-3 gap-2">
        <Act label={busy === "complete" ? "Saving…" : "Work Order Completed"} cls="bg-green-600 text-white" onClick={complete} testid="tech-finish-btn" />
        <Act label="Set Runback" cls="bg-amber-400 text-[#0f2f52]" onClick={() => check() && setPick(true)} testid="tech-notdone-btn" />
        <Act label={busy === "quote" ? "Saving…" : "Compile Quotation"} cls="bg-orange-500 text-white" onClick={() => check() && shut("quote")} testid="tech-quote-btn" />
      </div>
      {pick && <RunbackPicker date={v.date || date} busy={!!busy} onPick={(d, why) => shut("runback", d, why)} onCancel={() => setPick(false)} />}
      {note && <Notice lines={note} onOk={nav.home} />}
      {fin && <CompletePopup res={fin.res} texted={fin.texted} me={me()} date={v.date || date} nav={nav} />}
    </div>
  );
}
